import React, { useState } from "react";
import PropTypes from "prop-types";
import Transition from "../../../../client/common/Transition/Animation";
import style from "./index.scss";

const WhatsApp = () => {
  const [inputNumber, setInputNumber] = useState("");
  const [countryCode, setCountryCode] = useState("91");
  const [messageBox, setMessageBox] = useState("");
  // const onNumberPaste = (e) => {
  //   const data = e.target.value;
  //   if (data.length > 10) {
  //     setInputNumber(data.substring(data.length - 10, data.length));
  //   } else if (data.length == 10) {
  //     setInputNumber(data);
  //   }
  // };
  const validateData = () => {
    let res = false;
    if (inputNumber.length == 10) {
      if (countryCode.length == 2) {
        res = true;
      }
    }
    if (messageBox.length > 2) {
      res = true;
    }
    return res;
  };
  const onSubmit = () => {
    if (validateData()) {
      const finalNumber =
        inputNumber.length == 10 ? countryCode + inputNumber : "";
      const url = `https://wa.me/${finalNumber}?text=` + encodeURI(messageBox);
      if (window.mgInterface) {
        window.mgInterface.whatsApp(finalNumber, encodeURI(messageBox));
      } else {
        window.open(url, "_blank");
      }
    }
  };

  return (
    <Transition>
      <div className={style["whatsapp"]}>
        <div className={style["body-holder"]}>
          <div className={style["header"]}>What&apos;s App</div>
          <div className={style["holder"]}>
            <div className={style["number-container"]}>
              <div className={style["country-code-holder"]}>
                <label>Country Code</label>
                <input
                  type="tel"
                  name={"Country Code"}
                  placeholder={"Country Code"}
                  value={countryCode}
                  className={style["country-code-input"]}
                  onChange={(e) => {
                    setCountryCode(e.target.value);
                  }}
                />
              </div>
              <div className={style["number-holder"]}>
                <label>Number</label>
                <input
                  type="tel"
                  name={"Number"}
                  placeholder={"Number"}
                  value={inputNumber}
                  className={style["number-input"]}
                  onChange={(e) => setInputNumber(e.target.value)}
                />
              </div>
            </div>
            <div className={style["message-holder"]}>
              <div className={style["sub-header"]}>Message Box</div>
              <input
                className={style["message-input"]}
                type="text"
                name={"Message Box"}
                placeholder={"Message Box"}
                value={messageBox}
                onChange={(e) => {
                  setMessageBox(e.target.value);
                }}
              />
            </div>
            <div className={style["btn-holder"]}>
              <div className={style["submit-btn"]} onClick={onSubmit}>
                Submit
              </div>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  );
};
WhatsApp.prototype = {};

export default WhatsApp;
